import * as Yup from 'yup'

const Validation = Yup.object().shape({
  provider: Yup.string().required('Test provider is required'),
  dateOfTest: Yup.string()
    .required('Test taken date is required')
    .test({
      name: 'dateOfTest',
      message: 'Language test date can not be set in the future',
      test: (dateOfTest) => new Date(dateOfTest as string) < new Date(),
    }),
  expirationDate: Yup.string()
    .nullable()
    .test({
      name: 'expirationDate',
      message: 'Expiration date can not be before date of test',
      test: (expirationDate, context): boolean => {
        if (expirationDate) {
          return new Date(expirationDate) > new Date(context.parent.dateOfTest)
        } else return true
      },
    }),
  trainingTitle: Yup.object().shape({
    id: Yup.string().required('Language name is required'),
    translation: Yup.string(),
  }),
})

export default Validation
